/* import __COLOCATED_TEMPLATE__ from './empty-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();